import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { triggerFetchTimeStamp, unsetRun } from "../../redux/actions";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { getPartnerRoleID, isEmptyObject } from "../../utils/common/index";
import MyEarningsView from "../../views/myEarningsView";
import Spinner from "../../components/presentationals/Spinner";
import EarningsDevice from "./components/EarningDevice";
import CustomLandingBody from "../../components/customLandingBody";
import { triggerIsDashboardAccessible } from "../../redux/actions";

function MyEarnings(props) {
  const {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    isBusinessType,
    timestamp,
    tilesData,
  } = useSelector((state) => state.homeReducer);

  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  const { data } = getAllAPI;

  let earningModule, earningSection, moduleName;
  const dispatch = useDispatch();

  const [showAlert, setShowAlert] = useState(null);
  const [dashboardName, setDashboardName] = useState("My Earnings");

  if (!isEmptyObject(data)) {
    const { content: hierarchy } = data;
    earningModule = hierarchy
      ? hierarchy.filter((item) => item.moduleName === "My Earnings")
      : [];
    earningSection = earningModule && earningModule[0].modSecMasterTxDtos;
    moduleName = earningModule && earningModule[0].moduleName;
  }

  earningSection &&
    earningSection.sort((a, b) =>
      a.sectionName > b.sectionName ? 1 : b.sectionName > a.sectionName ? -1 : 0
    );

  let timeStampObj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      moduleName: moduleName,
      partnerRole: getPartnerRoleID(filterValue.selectedPartnerRoleName),
    },
  };

  useEffect(() => {
    const showHeader = () => {
      return dispatch(triggerShowHeader(true));
    };

    const unsetPayoutDashboardForCalender = () => {
      return dispatch(unsetPayoutDashboard());
    };
    unsetPayoutDashboardForCalender();

    const fetchTimeStamp = (item) => {
      timeStampObj.params = {
        ...timeStampObj.params,
        subModule: item.sectionName,
      };
      return dispatch(
        triggerFetchTimeStamp(timeStampObj, moduleName + item.sectionName)
      );
    };

    const earnings = () => {
      showHeader();
      if (
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content[0]
      ) {
        let offset = 0,
          timer;
        earningSection &&
          earningSection.forEach((item, index) => {
            // timer = setTimeout(async () => {
            //   fetchTimeStamp(item);
            // }, 50 * offset);
          });
        offset += 5000;
        return () => clearTimeout(timer);
      }
    };

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);
        earnings();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);
              earnings();
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);
      earnings();
    }
  }, [getAllAPI]);

  useEffect(() => {
    dispatch(unsetRun());
  }, []);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <MyEarningsView
      moduleName={moduleName}
      earningModule={earningModule}
      earningSection={earningSection}
      timeStampObj={timeStampObj}
      headerSelectedDateFrom={headerSelectedDateFrom}
      headerSelectedDateTo={headerSelectedDateTo}
      timestamp={timestamp}
      filterValue={filterValue}
      sectionName={moduleName}
      data={data}
      isBusinessType={isBusinessType}
      getAllAPI={getAllAPI}
      key={props.index}
      dashboardName={dashboardName}
    />
  );
}

export default MyEarnings;
